var setupNavigation = require('./navigation');

setupNavigation();